import { option } from '../lib/common'

export const COUNTER_MODE_COUNT = 'count'
export const COUNTER_MODE_TIMEOUT = 'timeout'
export const COUNTER_MODE_INTERVAL = 'interval'

export const COUNTER_MODE_LIST = [option('Count', COUNTER_MODE_COUNT), option('Timeout', COUNTER_MODE_TIMEOUT)]

export const COUNTER_VALUE_MODE_NUMERIC = 'numeric'
export const COUNTER_VALUE_MODE_DATE = 'date'
export const COUNTER_VALUE_MODE_TIME = 'time'
export const COUNTER_VALUE_MODE_DATE_TIME = 'date_time'

export const COUNTER_VALUE_MODE_LIST = [
  option('Numeric', COUNTER_VALUE_MODE_NUMERIC),
  option('Date', COUNTER_VALUE_MODE_DATE),
  option('Time', COUNTER_VALUE_MODE_TIME),
  option('DateTime', COUNTER_VALUE_MODE_DATE_TIME),
]
